import AccountBalanceIcon from "@mui/icons-material/AccountBalance"
import Diversity1Icon from "@mui/icons-material/Diversity1"
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom"
import HomeIcon from "@mui/icons-material/Home"
import SchoolIcon from "@mui/icons-material/School"
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  styled,
  useTheme,
} from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2"
import { motion } from "framer-motion"
import React, { useState } from "react"
import Header from "./Header"
import ModalSolicitudBancaria from "./modales/ModalSolicitudBancaria"
import ModalSolicitudDomicilio from "./modales/ModalSolicitudDomicilio"
import ModalSolicitudEducacion from "./modales/ModalSolicitudEducacion"
import ModalSolicitudEstadoCivil from "./modales/ModalSolicitudEstadoCivil"
import ModalSolicitudFamilia from "./modales/ModalSolicitudFamilia"
// import EarningIcon from 'assets/images/icons/earning.svg';
import { forwardRef } from "react"
import { useDispatch } from "react-redux"
import { clearSolicitudInfo } from "../Redux/solicitudes"
import { UserAuth } from "../context/AuthContext"
import ModalMisSolicitudes from "./modales/ModalMisSolicitudes"
import { analytics } from '../Firebase'
import { useLocation } from "react-router-dom"
const Solicitudes = () => {
  const theme = useTheme()
  const { empleado } = UserAuth()
  const location = useLocation();
  const dispatch = useDispatch()

  const [openEstadoCivil, setOpenEstadoCivil] = React.useState(false)
  const handleOpenEstadoCivil = () => setOpenEstadoCivil(true)
  const handleCloseEstadoCivil = () => setOpenEstadoCivil(false)

  const [openDomicilio, setOpenDomicilio] = React.useState(false)
  const handleOpenDomicilio = () => setOpenDomicilio(true)
  const handleCloseDomicilio = () => setOpenDomicilio(false)

  const [openFamilia, setOpenFamilia] = React.useState(false)
  const handleOpenFamilia = () => setOpenFamilia(true)
  const handleCloseFamilia = () => setOpenFamilia(false)

  const [openEducacion, setOpenEducacion] = React.useState(false)
  const handleOpenEducacion = () => setOpenEducacion(true)
  const handleCloseEducacion = () => setOpenEducacion(false)

  const [openBancaria, setOpenBancaria] = React.useState(false)
  const handleOpenBancaria = () => setOpenBancaria(true)
  const handleCloseBancaria = () => setOpenBancaria(false)

  const [openModal, setOpenModal] = React.useState(false)

  const [tipoSolicitud, setTipoSolicitud] = useState("")

  const handleOpenModal = (tipo) => {
    setOpenModal(true)
    setTipoSolicitud(tipo)
  }
  const handleCloseModal = () => {
    setOpenModal(false)
    setTipoSolicitud("")
    dispatch(clearSolicitudInfo())
  }

  React.useEffect(() => {
    if (empleado && empleado.usuarioPortalRh) {
      // Extraer el nombre de usuario de la dirección de correo electrónico
      const userEmail = empleado.usuarioPortalRh;
      const userName = userEmail.split('@')[0];

      // Enviar el evento a Firebase Analytics con el nombre de usuario
      analytics.logEvent('screen_view', {
        screen_name: location.pathname,
        user_email: userName,
      });
    }
  }, [empleado, location]);

  // ==============================|| CUSTOM MAIN CARD ||============================== //
  // constant
  const headerSX = {
    "& .MuiCardHeader-action": { mr: 0 },
  }

  const MainCard = forwardRef(
    (
      {
        border = true,
        boxShadow,
        children,
        content = true,
        contentClass = "",
        contentSX = {},
        darkTitle,
        secondary,
        shadow,
        sx = {},
        title,
        ...others
      },
      ref
    ) => {
      const theme = useTheme()

      return (
        <Card
          ref={ref}
          {...others}
          sx={{
            border: border ? "1px solid" : "none",
            borderColor: theme.palette.primary[200] + 25,
            ":hover": {
              boxShadow: boxShadow ? shadow || "0 2px 14px 0 rgb(32 40 45 / 8%)" : "inherit",
            },
            ...sx,
          }}
        >
          {/* card header and action */}
          {title && <CardHeader sx={headerSX} title={darkTitle ? <Typography variant="h3">{title}</Typography> : title} action={secondary} />}

          {/* content & header divider */}
          {title && <Divider />}

          {/* card content */}
          {content && (
            <CardContent sx={contentSX} className={contentClass}>
              {children}
            </CardContent>
          )}
          {!content && children}
        </Card>
      )
    }
  )

  const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.tertiary[600],
    color: theme.palette.primary.light,
    overflow: "hidden",
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: `linear-gradient(210.04deg, ${theme.palette.primary[200]} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
      borderRadius: "50%",
      top: -30,
      right: -180,
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: `linear-gradient(140.9deg, ${theme.palette.primary[200]} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
      borderRadius: "50%",
      top: -160,
      right: -130,
    },
  }))
  // ================================================================================== //

  // En esta page es necesario entrar a los formularios de dynamics o wordpress y ver que campos se necesitan para pasar al metodo que armara Juan. //
  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1.5rem 2.5rem">
        <Header title={"Solicitudes"} subtitle="En esta sección, podrás solicitar actualización de tus datos personales como Domicilio, Familia, Estado Civil, Educación y Cuenta Bancaria.  " />
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} sm={6}>
            <CardWrapper border={false} content={false}>
              <Box sx={{ p: 2 }}>
                <List sx={{ py: 0 }}>
                  <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                    <ListItemAvatar>
                      <Avatar
                        variant="rounded"
                        sx={{
                          ...theme.typography.commonAvatar,
                          ...theme.typography.largeAvatar,
                          backgroundColor: theme.palette.primary[800],
                          color: "#fff",
                        }}
                      >
                        <HomeIcon fontSize="inherit" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      sx={{
                        py: 0,
                        mt: 0.45,
                        mb: 0.45,
                      }}
                      primary={
                        <Typography variant="h4" sx={{ color: "#fff" }}>
                          Solicitud Actualización Domicilio
                        </Typography>
                      }
                      secondary={
                        <Typography variant="subtitle2" sx={{ color: "primary.light", mt: 0.25 }}>
                          Aquí podrás solicitar la actualización de tu domicilio.
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              </Box>
              <Box sx={{ p: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "flex-end", gap: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleOpenModal("domicilio")
                  }}
                >
                  Ver Solicitudes
                </Button>
                <Button variant="contained" onClick={handleOpenDomicilio}>
                  Solicitar
                </Button>
              </Box>
            </CardWrapper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <CardWrapper border={false} content={false}>
              <Box sx={{ p: 2 }}>
                <List sx={{ py: 0 }}>
                  <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                    <ListItemAvatar>
                      <Avatar
                        variant="rounded"
                        sx={{
                          ...theme.typography.commonAvatar,
                          ...theme.typography.largeAvatar,
                          backgroundColor: theme.palette.primary[800],
                          color: "#fff",
                        }}
                      >
                        <Diversity1Icon fontSize="inherit" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      sx={{
                        py: 0,
                        mt: 0.45,
                        mb: 0.45,
                      }}
                      primary={
                        <Typography variant="h4" sx={{ color: "#fff" }}>
                          Solicitud Actualización Estado Civil
                        </Typography>
                      }
                      secondary={
                        <Typography variant="subtitle2" sx={{ color: "primary.light", mt: 0.25 }}>
                          Aquí podrás solicitar la actualización de tu Estado Civil.
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              </Box>
              <Box sx={{ p: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "flex-end", gap: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleOpenModal("estado civil")
                  }}
                >
                  Ver Solicitudes
                </Button>
                <Button variant="contained" onClick={handleOpenEstadoCivil}>
                  Solicitar
                </Button>
              </Box>
            </CardWrapper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <CardWrapper border={false} content={false}>
              <Box sx={{ p: 2 }}>
                <List sx={{ py: 0 }}>
                  <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                    <ListItemAvatar>
                      <Avatar
                        variant="rounded"
                        sx={{
                          ...theme.typography.commonAvatar,
                          ...theme.typography.largeAvatar,
                          backgroundColor: theme.palette.primary[800],
                          color: "#fff",
                        }}
                      >
                        <FamilyRestroomIcon fontSize="inherit" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      sx={{
                        py: 0,
                        mt: 0.45,
                        mb: 0.45,
                      }}
                      primary={
                        <Typography variant="h4" sx={{ color: "#fff" }}>
                          Solicitud Actualización Familiar
                        </Typography>
                      }
                      secondary={
                        <Typography variant="subtitle2" sx={{ color: "primary.light", mt: 0.25 }}>
                          Aquí podrás solicitar la actualización de tu familia.
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              </Box>
              <Box sx={{ p: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "flex-end", gap: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleOpenModal("familia")
                  }}
                >
                  Ver Solicitudes
                </Button>
                <Button variant="contained" onClick={handleOpenFamilia}>
                  Solicitar
                </Button>
              </Box>
            </CardWrapper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <CardWrapper border={false} content={false}>
              <Box sx={{ p: 2 }}>
                <List sx={{ py: 0 }}>
                  <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                    <ListItemAvatar>
                      <Avatar
                        variant="rounded"
                        sx={{
                          ...theme.typography.commonAvatar,
                          ...theme.typography.largeAvatar,
                          backgroundColor: theme.palette.primary[800],
                          color: "#fff",
                        }}
                      >
                        <SchoolIcon fontSize="inherit" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      sx={{
                        py: 0,
                        mt: 0.45,
                        mb: 0.45,
                      }}
                      primary={
                        <Typography variant="h4" sx={{ color: "#fff" }}>
                          Solicitud Actualización de Educación Formal
                        </Typography>
                      }
                      secondary={
                        <Typography variant="subtitle2" sx={{ color: "primary.light", mt: 0.25 }}>
                          Aquí podrás solicitar la actualización de tu educación.
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              </Box>
              <Box sx={{ p: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "flex-end", gap: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleOpenModal("educacion")
                  }}
                >
                  Ver Solicitudes
                </Button>
                <Button variant="contained" onClick={handleOpenEducacion}>
                  Solicitar
                </Button>
              </Box>
            </CardWrapper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <CardWrapper border={false} content={false}>
              <Box sx={{ p: 2 }}>
                <List sx={{ py: 0 }}>
                  <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                    <ListItemAvatar>
                      <Avatar
                        variant="rounded"
                        sx={{
                          ...theme.typography.commonAvatar,
                          ...theme.typography.largeAvatar,
                          backgroundColor: theme.palette.primary[800],
                          color: "#fff",
                        }}
                      >
                        <AccountBalanceIcon fontSize="inherit" />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      sx={{
                        py: 0,
                        mt: 0.45,
                        mb: 0.45,
                      }}
                      primary={
                        <Typography variant="h4" sx={{ color: "#fff" }}>
                          Solicitud Actualización de Cuenta Bancaria
                        </Typography>
                      }
                      secondary={
                        <Typography variant="subtitle2" sx={{ color: "primary.light", mt: 0.25 }}>
                          Aquí podrás solicitar la actualización de tus cuenta.
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              </Box>
              <Box sx={{ p: 2, display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "flex-end", gap: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleOpenModal("cuenta bancaria")
                  }}
                >
                  Ver Solicitudes
                </Button>
                <Button variant="contained" onClick={handleOpenBancaria}>
                  Solicitar
                </Button>
              </Box>
            </CardWrapper>
          </Grid>
        </Grid>
      </Box>
      {openDomicilio && <ModalSolicitudDomicilio open={openDomicilio} handleClose={handleCloseDomicilio} />}
      {openEstadoCivil && <ModalSolicitudEstadoCivil open={openEstadoCivil} handleClose={handleCloseEstadoCivil} />}
      {openFamilia && <ModalSolicitudFamilia open={openFamilia} handleClose={handleCloseFamilia} />}
      {openEducacion && <ModalSolicitudEducacion open={openEducacion} handleClose={handleCloseEducacion} />}
      {openBancaria && <ModalSolicitudBancaria open={openBancaria} handleClose={handleCloseBancaria} />}
      {openModal && <ModalMisSolicitudes open={openModal} handleClose={handleCloseModal} tipoSolicitud={tipoSolicitud} />}
    </motion.div>
  )
}

export default Solicitudes
